import React, { useRef, useState } from 'react'
import classNames from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCamera, faTimes } from '@fortawesome/free-solid-svg-icons'
import { Badge } from 'reactstrap'
import FieldError from '../FieldError'
import { MAX_PHOTO_MB, MAX_SERVICE_PHOTOS, MIN_SERVICE_PHOTOS, PHOTO_ACCEPT, isFileTooBig } from '../../marketplaceConstants'

const TILE_STYLE = { width: 120, height: 120 }

const ServicePhotosField = ({ photos, onAdd, onRemove, error, max = MAX_SERVICE_PHOTOS, hint, showCover = true }) => {
  const inputRef = useRef()
  const [localError, setLocalError] = useState(null)
  const remaining = max - photos.length

  const handleFiles = (fileList) => {
    const files = Array.from(fileList || [])
    const tooBig = files.filter((file) => isFileTooBig(file, MAX_PHOTO_MB))
    const accepted = files.filter((file) => !isFileTooBig(file, MAX_PHOTO_MB)).slice(0, remaining)
    const skipped = files.length - tooBig.length - accepted.length

    if (tooBig.length) {
      setLocalError(`${tooBig.length === 1 ? 'Una foto pesa' : `${tooBig.length} fotos pesan`} más de ${MAX_PHOTO_MB} MB y no se agregó.`)
    } else if (skipped > 0) {
      setLocalError(`Solo puedes tener ${max} fotos; no se agregaron ${skipped}.`)
    } else {
      setLocalError(null)
    }

    if (accepted.length) onAdd(accepted)
  }

  return (
    <>
      <div className="d-flex flex-wrap" style={{ gap: 12 }}>
        {photos.map((photo, index) => (
          <div key={photo.key} className="position-relative rounded overflow-hidden border" style={TILE_STYLE}>
            <img src={photo.url} alt="" className="w-100 h-100" style={{ objectFit: 'cover' }} />
            {index === 0 && showCover && (
              <Badge color="primary" className="position-absolute" style={{ left: 6, bottom: 6 }}>
                Portada
              </Badge>
            )}
            <button
              type="button"
              className="btn btn-sm btn-danger position-absolute d-flex align-items-center justify-content-center p-0"
              style={{ top: 6, right: 6, width: 26, height: 26, borderRadius: 6 }}
              onClick={() => {
                setLocalError(null)
                onRemove(photo.key)
              }}
              title="Quitar foto"
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
        ))}
        {remaining > 0 && (
          <button
            type="button"
            onClick={() => inputRef.current.click()}
            className={classNames('rounded d-flex flex-column align-items-center justify-content-center text-600', {
              'border-danger': error || localError
            })}
            style={{ ...TILE_STYLE, border: '2px dashed #d8e2ef', backgroundColor: '#f9fafd' }}
          >
            <FontAwesomeIcon icon={faCamera} size="lg" className="mb-1" />
            <span className="fs--2 font-weight-semi-bold">Agregar fotos</span>
            <span className="fs--2 text-500">{photos.length}/{max}</span>
          </button>
        )}
      </div>
      <input
        ref={inputRef}
        type="file"
        accept={PHOTO_ACCEPT}
        multiple
        className="d-none"
        onChange={({ target }) => {
          handleFiles(target.files)
          target.value = ''
        }}
      />
      <small className="text-600 d-block mt-2">
        {hint ||
          `Entre ${MIN_SERVICE_PHOTOS} y ${MAX_SERVICE_PHOTOS} fotos de trabajos que hayas hecho, idealmente el antes y el después. JPG, PNG o WEBP de hasta ${MAX_PHOTO_MB} MB. La primera es la portada.`}
      </small>
      <FieldError error={localError || error} />
    </>
  )
}

export default ServicePhotosField
